import { useContext } from 'react';
import { ThemeProviderContext } from './theme-context';

export const useTheme = () => {
    const context = useContext(ThemeProviderContext);

    return context;
};
